<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <Breadcrumb>
              <div class="active section">
                <div class="neutral">Planos</div>
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <form @submit.prevent="search()" class="ui small form search-form">
              <div class="fields">
                <div class="two wide field">
                  <label for="plan-search-cod">Código</label>
                  <input
                    type="text"
                    name="plan-search-cod"
                    v-model="searchForm.cod"
                  />
                </div>
                <div class="six wide field">
                  <label for="plan-search-description">Descrição</label>
                  <input
                    type="text"
                    name="plan-search-description"
                    v-model="searchForm.description"
                  />
                </div>
                <div class="end field">
                  <input
                    type="submit"
                    name="commit"
                    value="Filtrar"
                    class="ui button"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="sixteen wide column">
            <Grid
              ref="grid"
              :columns="gridColumns"
              resource="plans"
              @refresh="search()"
              @page="n => search(n)"
            />
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import Grid from '@/components/grid';
import SearchMixins from '@/mixins/search_mixins';

export default {
  name: 'plans',
  mixins: [SearchMixins],
  components: { Grid, Breadcrumb, PageLayout },

  data() {
    return {
      searchForm: {
        description: null,
        cod: null
      },
      query: {},
      gridColumns: [
        { description: null, kind: 'status', field: 'enable' },
        { description: null, kind: 'edit', field: 'id' },
        { description: 'Cod', field: 'id' },
        { description: 'Plano', field: 'description' }
      ]
    };
  },

  mounted() {
    this._initSearchForm();
    this.search(this.$route.query.page);
  },

  methods: {
    search(page = 1) {
      this._addSearchToQueryParams();

      const query = {
        q: {
          description_cont: this.searchForm.description,
          id_eq: this.searchForm.cod
        },
        page: page
      };

      this.$refs.grid.toggleLoading();
      Api.plans
        .search(query)
        .then(async response => {
          // const items = response.data.plans.map(u => [u.enable, u.id, u.description]);
          this.$refs.grid.setItems(response.data.plans);
          this.$refs.grid.setPaginate(response.data.pagination);
        })
        .catch(error => {
          this.$toast.show('Erro ao carregar', 'error');
          throw error;
        })
        .finally(() => {
          this.$refs.grid.toggleLoading();
        });
    }
  }
};
</script>
